module.exports = __webpack_public_path__ + "img/16.1bd93df3.svg";